import React, { useEffect, useState } from "react";
import JallipoolService from "../../services/jallipool.service";
import moment from "moment";
import dayjs from "dayjs";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
Chart.register(ChartDataLabels);

function DefectWiseReport() {
  const [minorData, setMinorData] = useState([]);
  const [majorData, setMajorData] = useState([]);
  const [activeYearly, setActiveYearly] = useState(2);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMajorData();
  }, [activeYearly]);

  const fetchMajorData = () => {
    setLoading(true);
    const req = {
      type: activeYearly.toString(),
      deffectype: "1", //Major Defect
    };
    JallipoolService.getDefectWiseReport(req)
      .then((response) => {
        if (response.data) {
          setLoading(false);
          setMajorData(response.data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchMinorData();
  }, [activeYearly]);

  const fetchMinorData = () => {
    setLoading(true);
    const req = {
      type: activeYearly.toString(),
      deffectype: "2", //Minor Defect
    };
    JallipoolService.getDefectWiseReport(req)
      .then((response) => {
        if (response.data) {
          setLoading(false);
          setMinorData(response.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const generateLast7DaysData = () => {
    if (minorData.length != 0) {
      const data = minorData.map((item) =>
        moment(item.month_Year, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY")
      );
      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (minorData.length != 0) {
      const data = minorData.map((itm) => itm.month_Year);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 2
      ? generateLast7DaysData()
      : activeYearly === 1
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const chartData = {
    labels: data,
    datasets: [
      {
        label: "Minor Defect",
        data: minorData.map((item) => item.defectcount),
        backgroundColor: "rgb(21, 214, 130)",
        // barPercentage: 0.75,
        categoryPercentage: activeYearly === 1 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      },
      {
        label: "Major Defect",
        data: majorData.map((item) => item.defectcount),
        backgroundColor: "rgb(253, 84, 78)",
        // barPercentage: 0.75,
        categoryPercentage: activeYearly === 1 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      },
    ],
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.formattedValue;
            return `${label}: ${value}`;
          },
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },
      },
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawOnChartArea: true,
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          drawOnChartArea: true,
        },
        ticks: {
          beginAtZero: true,
        },
        suggestedMin: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: "Count",
        },
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
  };
  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };
  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">Defect Wise Report</div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>

      <div className="">
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border "
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : (
          <>
            <div className="">
              <Bar
                data={chartData}
                options={options}
                width={600}
                height={300}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default DefectWiseReport;
